const KEY = 'cartDrawerCountdownDeadline';
const DURATION_MS = 10 * 60 * 1000;

function getDeadline() {
  let deadline = parseInt(sessionStorage.getItem(KEY), 10);
  if (!deadline || deadline < Date.now()) {
    deadline = Date.now() + DURATION_MS;
    sessionStorage.setItem(KEY, String(deadline));
  }
  return deadline;
}

const deadline = getDeadline();

function update() {
  const els = document.querySelectorAll('[data-cart-countdown-time]');
  if (!els.length) return;
  const remaining = Math.max(0, deadline - Date.now());
  const minutes = Math.floor(remaining / 60000);
  const seconds = Math.floor((remaining % 60000) / 1000);
  const label = `${minutes}:${seconds < 10 ? '0' : ''}${seconds}`;
  els.forEach((el) => {
    el.textContent = label;
  });
}

update();
setInterval(update, 1000);
